import * as React from 'react';

import { 
    makeLayout, makeLayoutSlot, Effects,
    makeEntry, makePluginSlot,
    IControllerContext, IPluginContext, ISlotContext, 
} from '../../core/Slot';

import { Props as AcceptProps } from './Accept';
import Body, { Props as BodyProps } from './Body';
import { Props as CancelProps } from './Cancel';
import Close, { Props as CloseProps } from './Close';
import Footer, { Props as FooterProps } from './Footer';
import Header, { Props as HeaderProps } from './Header';
import Title, { Props as TitleProps } from './Title';


export const URI = 'Modal';
export type URI = typeof URI;


declare module '../../core/Slot' {
    interface URItoKind {
        [URI]: {
            slots: {
                header: { 
                    innerProps: Pick<HeaderProps, 'handleClose'>, 
                    outerProps: Pick<HeaderProps, 'children' | 'className'>,
                },
                title: { 
                    innerProps: {}, 
                    outerProps: Pick<TitleProps, 'children' | 'className'>,
                },
                close: {
                    innerProps: Pick<CloseProps, 'handleClose'>, 
                    outerProps: Pick<CloseProps, 'className'>,
                },
                body: { 
                    innerProps: {}, 
                    outerProps: Pick<BodyProps, 'children' | 'className'>,
                },
                footer: {
                    innerProps: Pick<FooterProps, 'handleClose' | 'accept'>,
                    outerProps: Pick<FooterProps, 'children' | 'className'>,
                },
                accept: { 
                    innerProps: Pick<AcceptProps, 'accept'>, 
                    outerProps: Pick<AcceptProps, 'children' | 'className'>,
                },
                cancel: {
                    innerProps: Pick<CancelProps, 'handleClose'>, 
                    outerProps: Pick<CancelProps, 'children' | 'className'>,
                },
            },
            controllers: {},
            effects: [],
            plugins: {
                accept_tooltiped: {
                    target: 'accept',
                    props: {
                        text: string,
                        disabled?: boolean,
                    }
                }
            },
        },
    }
}

const SlotContext = React.createContext({} as ISlotContext<URI>);
const ControllerContext = React.createContext({} as IControllerContext<URI>);
const EffectContext = React.createContext({} as Effects<URI>);
const PluginContext = React.createContext({} as IPluginContext<URI>);

const emptyF = () => () => {};
const emptyChildren = () => () => null;
const emptyClassName = () => undefined;

const def = {
    children: emptyChildren,
    className: emptyClassName,
}

export const makeSlot = makeLayoutSlot(SlotContext);
export const Entry = makeEntry({
    SlotContext,
    ControllerContext,
    EffectContext,
    PluginContext,
    initControllers: {},
    initSlots: {
        header: {
            props: {
                handleClose: emptyF,
                ...def
            },
            component: Header,
        },
        title: {
            props: def,
            component: Title,
        },
        close: {
            props: {
                handleClose: emptyF,
            },
            component: Close,
        },
        body: {
            props: def,
            component: Body,
        },
        footer: {
            props: {
                handleClose: emptyF,
                accept: emptyF,
                ...def,
            },
            component: Footer,
        },
        accept: {
            props: {
                ...def,
                accept: emptyF,
                children: () => 'Принять',
            },
            component: () => null,
        },
        cancel: {
            props: {
                ...def,
                handleClose: emptyF,
                children: () => 'Закрыть'
            },
            component: () => null,
        },
    },
    initEffect: [],
});

export const Layout = makeLayout(SlotContext);
export const plugin = makePluginSlot({ PluginContext, SlotContext });
